import { ListItem, ListItemButton, ListItemText, List } from '@mui/material';
import React, { Component } from 'react';
import Loading from './loading';
import OverWindow from './TabList/OverWindow';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import InputWithClear from './InputComponents/InputWithClear';
import InputTypesEnum from '../Enums/InputTypesEnum';
import ErrorMessage from './ErrorMessage';
import FigmaButton from './FigmaButton';

export default class MultiSelectList extends Component {
  static defaultProps = {
    title: 'Add Items',
    clickOnCancel: () => {
      alert('Empty function');
    },
    onSaveFunction: () => {
      alert('Empty function');
    },
    requestItem: {},
    serviceFunction: () => {
      alert('Empty function');
    },
    convertedDBItemsFunction: () => {
      alert('Empty function');
    },
    itemType: {},
    searchItem: null,
    cancelButtonText: 'Cancel',
    submitButtonText: 'Create',
  };

  constructor(props) {
    super(props);
    this.state = {
      SearchValues: {
        newSearchValue: '',
        selectedSearchValue: '',
      },
      ConvertedResult: [],
      selectedIndexInSource: [],
      selectedIndexInDest: [],
      saving: false,
    };
  }

  componentDidMount() {
    this.populateList();
  }

  populateList() {
    this.props
      .serviceFunction(this.props.searchItem)
      .then((result) => {
        const convertedResult = this.props.convertDBItemsFunction(result);
        this.setState({
          ConvertedResult: convertedResult,
        });
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('MSL60');
      });
  }

  changeOfReportItem(fieldName, newValue) {
    const newReportItem = {
      ...this.state.SearchValues,
      [fieldName]: newValue,
    };
    this.setState({ SearchValues: newReportItem });
  }

  handleListItemClickInDest(e, index) {
    let newList = this.state.selectedIndexInDest;
    if (newList.includes(index)) {
      newList = newList.filter((i) => i !== index);
    } else {
      newList.push(index);
    }
    this.setState({ selectedIndexInDest: newList });
  }

  handleListItemClickInSource(e, index) {
    let newList = this.state.selectedIndexInSource;
    if (newList.includes(index)) {
      newList = newList.filter((i) => i !== index);
    } else {
      newList.push(index);
    }
    this.setState({
      selectedIndexInSource: newList,
    });
  }

  moveToOrFromDestination(indexList, selected) {
    if (indexList.length === 0) {
      return;
    }
    const tempConvertedResult = this.state.ConvertedResult;
    tempConvertedResult.forEach((i, index) => {
      if (indexList.includes(index)) i.SelectedInList = selected;
    });

    this.setState({
      ConvertedResult: tempConvertedResult,
      selectedIndexInSource: [],
      selectedIndexInDest: [],
    });
  }

  moveAllToOrFromDestination(selected) {
    const tempConvertedResult = this.state.ConvertedResult;
    tempConvertedResult.forEach((mt) => (mt.SelectedInList = selected));

    this.setState({
      ConvertedResult: tempConvertedResult,
      selectedIndexInSource: [],
      selectedIndexInDest: [],
    });
  }

  clickOnSaveButton = () => {
    this.props.requestItem.setIdList(this.state.ConvertedResult);
    if (this.props.requestItem.length === 0) return;

    this.props
      .onSaveFunction(this.props.requestItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else if (result) {
          ErrorMessage.SetNotification(result);
        }
        this.props.clickOnCancel(true);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage('MSL131');
        this.setState({ saving: false });
      });
    this.setState({ saving: true });
  };

  displayedInListItem(item) {
    if (typeof this.props.itemType.displayedInList === 'function') {
      return this.props.itemType.displayedInList(item);
    }
    return item[this.props.itemType.displayedInList];
  }

  renderSourceList() {
    const ListOfData =
      this.state.SearchValues.newSearchValue === ''
        ? [...this.state.ConvertedResult]
        : this.state.ConvertedResult.filter((i) =>
            this.displayedInListItem(i).toLowerCase().includes(this.state.SearchValues.newSearchValue.toLowerCase())
          );

    return (
      <div className='p-1 m-1'>
        <div className='Figma-input-group'>
          <InputWithClear
            placeholder={'Search for items'}
            fieldName={'newSearchValue'}
            labelText={'select'}
            value={this.state.SearchValues['newSearchValue']}
            type={InputTypesEnum.Text2}
            onChange={(fieldName, newValue) => this.changeOfReportItem(fieldName, newValue)}
          />
        </div>
        <List
          className='FigmafixedHeightList'
          dense={true}
          component='div'
          role='list'
        >
          {this.state.ConvertedResult.map((e, index) => {
            if (!ListOfData.includes(e)) return null;

            return e.SelectedInList ? null : (
              <ListItemButton
                key={`lik${index}`}
                selected={this.state.selectedIndexInSource.includes(index)}
                onClick={(e) => this.handleListItemClickInSource(e, index)}
              >
                <ListItemText primary={`${this.displayedInListItem(e)}`} />
              </ListItemButton>
            );
          })}
        </List>
      </div>
    );
  }

  renderListButtons() {
    return (
      <div className='MulitInserMiddleButtonList'>
        <FigmaButton
          iconName='fa-solid fa-angles-right'
          type={ButtonTypeEnum.NormalIconOnly}
          color={ButtonColorsEnum.Common}
          iconPosition={IconPositionEnum.Center}
          onClick={() => this.moveAllToOrFromDestination(true)}
        />
        <FigmaButton
          iconName='fa-solid fa-angle-right'
          type={ButtonTypeEnum.NormalIconOnly}
          color={ButtonColorsEnum.Common}
          iconPosition={IconPositionEnum.Center}
          onClick={() => this.moveToOrFromDestination(this.state.selectedIndexInSource, true)}
        />
        <FigmaButton
          iconName='fa-solid fa-angle-left'
          type={ButtonTypeEnum.NormalIconOnly}
          color={ButtonColorsEnum.Common}
          iconPosition={IconPositionEnum.Center}
          onClick={() => this.moveToOrFromDestination(this.state.selectedIndexInDest, false)}
        />
        <FigmaButton
          iconName='fa-solid fa-angles-left'
          type={ButtonTypeEnum.NormalIconOnly}
          color={ButtonColorsEnum.Common}
          iconPosition={IconPositionEnum.Center}
          onClick={() => this.moveAllToOrFromDestination(false)}
        />
      </div>
    );
  }

  renderDestList() {
    const ListOfData =
      this.state.SearchValues.selectedSearchValue === ''
        ? [...this.state.ConvertedResult]
        : this.state.ConvertedResult.filter((i) =>
            this.displayedInListItem(i)
              .toLowerCase()
              .includes(this.state.SearchValues.selectedSearchValue.toLowerCase())
          );

    return (
      <div className='p-1 m-1'>
        <div className='Figma-input-group'>
          <InputWithClear
            placeholder={'Search for selected items'}
            fieldName={'selectedSearchValue'}
            labelText={'select'}
            value={this.state.SearchValues.selectedSearchValue}
            type={InputTypesEnum.Text2}
            onChange={(fieldName, newValue) => this.changeOfReportItem(fieldName, newValue)}
          />
        </div>
        <List
          className='FigmafixedHeightList'
          dense={true}
          component='div'
          role='list'
        >
          {this.state.ConvertedResult.map((e, index) => {
            if (!ListOfData.includes(e)) return null;

            return e.SelectedInList ? (
              <ListItemButton
                key={`lik${index}`}
                selected={this.state.selectedIndexInDest.includes(index)}
                onClick={(e) => this.handleListItemClickInDest(e, index)}
              >
                <ListItemText primary={`${this.displayedInListItem(e)}`} />
              </ListItemButton>
            ) : null;
          })}
        </List>
      </div>
    );
  }

  renderList() {
    return (
      <div>
        <div className='container-fluid  border rounded m-1 p-1 '>
          <div className='row'>
            <div className='col-5'>{this.renderSourceList()}</div>
            <div className='col-2'>{this.renderListButtons()}</div>
            <div className='col-5'>{this.renderDestList()}</div>
          </div>
        </div>
      </div>
    );
  }

  renderCancelAndSubmitButtons() {
    return (
      <div className='EditBoxFooter'>
        <div className='EditBoxFooterRight'>
          <FigmaButton
            label={this.props.cancelButtonText ? this.props.cancelButtonText : 'Cancel'}
            type={ButtonTypeEnum.NormalIconLeft}
            color={ButtonColorsEnum.Common}
            iconPosition={IconPositionEnum.Left}
            onClick={() => this.props.clickOnCancel(false)}
            disabled={this.state.saving}
          />
          <FigmaButton
            label={this.props.submitButtonText ? this.props.submitButtonText : 'Create'}
            onClick={() => this.clickOnSaveButton()}
            type={ButtonTypeEnum.NormalIconLeft}
            color={ButtonColorsEnum.Primary}
            iconPosition={IconPositionEnum.Left}
            iconName={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
            disabled={this.state.saving || this.state.ConvertedResult.filter((i) => i.SelectedInList).length === 0}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <OverWindow
        title={this.props.title}
        clickOnCancel={() => {
          if (!this.state.saving) this.props.clickOnCancel(false);
        }}
        closeOnClickOutside={false}
        iconName='fa-solid fa-plus-circle'
        maxWidth={950}
      >
        {/* Opt into the DS scope (like EditOverWindow / AddNewAttachmentWindow) so the
            search inputs and buttons pick up dark-mode-aware DS theming — a plain
            OverWindow otherwise leaves this content as unstyled (white) Bootstrap. */}
        <div className='p-1 m-1 bravo-ds'>
          {this.state.saving ? <Loading /> : this.renderList()}
          {this.renderCancelAndSubmitButtons()}
        </div>
      </OverWindow>
    );
  }
}
